if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.senderNameInput = this.querySelector(`#Recipient-sender-name-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.charCounter = this.querySelector('#remaining-chars');
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.currentProductVariantId = this.dataset.productVariantId;
        this.validate = this.validate.bind(this);
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        // eslint-disable-next-line no-undef
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        // eslint-disable-next-line no-undef
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        // eslint-disable-next-line no-undef
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });

        this.max = parseInt(this.messageInput.getAttribute('maxlength') || 500, 10);

        if (this.charCounter && this.messageInput) {
          this.charCounter.textContent = `${this.max} characters remaining`;
          this.messageInput?.addEventListener('input', () => {
            const remaining = this.max - this.messageInput?.value.length;
            this.charCounter.textContent = `${remaining} characters remaining`;
          });
        }

        this.senderNameInput.addEventListener('input', () => this.clearError(this.senderNameInput));
        this.nameInput.addEventListener('input', () => this.clearError(this.nameInput));
        this.emailInput.addEventListener('input', () => this.clearError(this.emailInput));
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      validate() {
        const isValidEmail = (email) => {
          return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        };

        const fields = [
          {
            input: this.senderNameInput,
            errorId: `RecipientForm-sender-name-error-${this.dataset.sectionId}`,
            message: 'Sender name is required.',
          },
          {
            input: this.nameInput,
            errorId: `RecipientForm-name-error-${this.dataset.sectionId}`,
            message: 'Recipient name is required.',
          },
          {
            input: this.emailInput,
            errorId: `RecipientForm-email-error-${this.dataset.sectionId}`,
            message: !this.emailInput?.value.trim()
              ? 'Recipient email is required.'
              : 'Please enter a valid email address.',
            isValid: (input) => !!input?.value.trim() && isValidEmail(input.value),
          },
        ];

        let valid = true;

        fields.forEach(({ input, errorId, message, isValid }) => {
          const errorEl = this.querySelector(`#${errorId}`);

          const fieldIsValid = typeof isValid === 'function' ? isValid(input) : input?.value?.trim();

          if (!fieldIsValid) {
            input?.classList.add('field__input--error');
            input?.setAttribute('aria-invalid', 'true');
            input?.setAttribute('aria-describedby', errorId);
            if (errorEl) {
              errorEl.classList.remove('hidden');
              const msgSpan = errorEl.querySelector('.error-message');
              if (msgSpan) msgSpan.textContent = message;
            }
            valid = false;
          } else {
            input?.classList.remove('field__input--error');
            if (errorEl) errorEl.classList.add('hidden');
          }
        });

        return valid;
      }

      clearError(input) {
        if (!input) return;
        input.classList.remove('field__input--error');
        const errorId = input.dataset.errorId;
        const errorEl = this.querySelector(`#${errorId}`);
        if (errorEl) errorEl.classList.add('hidden');
        input?.setAttribute('aria-invalid', 'false');
      }

      inputFields() {
        return [this.emailInput, this.senderNameInput, this.nameInput, this.messageInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      resetRecipientForm() {
        this.clearInputFields();
        if (this.charCounter) {
          this.charCounter.textContent = `${this.max} characters remaining`;
        }
      }
    },
  );
}
